import {
  AfterViewInit, Component, ViewChild,
  Input, Output, ElementRef, EventEmitter
} from '@angular/core';
import { FormGroup } from '@angular/forms';

declare const $: any;

@Component({
  selector: 'combobox',
  template: `
  <select id="{{name}}" name="{{name}}" class="mdb-select colorful-select dropdown-ins" [(ngModel)]="optionSelected" #select>
    <option *ngFor="let option of options" [value]="option.value" data-icon="assets/data/img/flags/language001-3232.png" class="rounded">{{option.code}}</option>
  </select>
  <label>{{label}}</label>`
})

export class ComboBoxComponent implements AfterViewInit {
  @Input() public name: string = '';
  @Input() public optionSelected: any;
  @Input() public options: any[];
  @Input() public label: string = '';
  @Input() public formGroup: FormGroup;
  @ViewChild('select') select: ElementRef;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  //  @Input() public enabled: Boolean = false;

  public firstLoad: boolean = true;
  constructor() {
  }

  ngAfterViewInit() {
    if (this.firstLoad) {
      this.firstLoad = false;
      setTimeout(() => {
        $(this.select.nativeElement).material_select();
        $(this.select.nativeElement).on('change', function (this: any, $event: any) {
        }, ($event: any) => {
          this.onChange($event);
        });
      }, 500);
    }
  }

  onChange(event: any) {
    if (this.optionSelected != event.target.value) {
      this.optionSelected = event.target.value;
      this.change.emit(this.optionSelected);
    }
  }

  ngOnDestroy() {
    $(this.select.nativeElement).material_select('destroy');
  }
}
